module.exports = __webpack_public_path__ + "static/img/card1.68ba5f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/card1.png
// module id = 3uTJ
// module chunks = 1